import { render, staticRenderFns } from "./posts2.vue?vue&type=template&id=10fe71a6&scoped=true&"
import script from "./posts2.vue?vue&type=script&lang=js&"
export * from "./posts2.vue?vue&type=script&lang=js&"
import style0 from "./posts2.vue?vue&type=style&index=0&id=10fe71a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe71a6",
  null
  
)

export default component.exports